<div *ngIf="logon ; else showLogin">
  <app-side-bar></app-side-bar>



  <!-- !PAGE CONTENT! -->
  <div class="w3-main" style="margin-left:300px;margin-top:43px;">

    <div [@routeAnimations]="prepareRoute(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>

    </div>

    <!-- End page content -->
  </div>
</div>


<ng-template #showLogin>
  <div
    style=" background-color: rgba(0, 0, 0, 0.2);filter: blur(5px);width:100%; height:100%;background-size: cover;background-image: url('https://source.unsplash.com/random/853x480/?biology,animal,microbiology,plant,physiology,food,nutrition,biochemistry,biotechnology,immunology,cytology,digestion,respiration,photosynthsis,ecology,biodiversity/?t=1')">

  </div>
  <div class="w3-display-middle w3-display-container w3-animate-opacity w3-text-white">

    <h1 class="w3-jumbo w3-animate-top">StudyBio</h1>
    <hr>
    <p class="w3-large w3-center"><button mat-button id="google_signin_button">Login with Google</button></p>

    <p class="w3-center w3-text-red">{{message}}</p>




  </div>
</ng-template>